// The handful of places most searches are really looking for. Shown under the
// search box in the header panel and on the empty search page, so both offer
// the same shortcuts and a change here reaches both.
export type QuickLink = { label: string; href: string; blurb?: string };

export const SEARCH_QUICK_LINKS: QuickLink[] = [
  { label: "Locations", href: "/locations", blurb: "Every city and centre" },
  { label: "Solutions", href: "/solutions", blurb: "Managed offices, suites, DESYN" },
  { label: "Global Capability Centers", href: "/solutions/global-capability-center" },
  { label: "Blog", href: "/blog", blurb: "Guides and insight" },
  { label: "Contact", href: "/contact-us", blurb: "Talk to Sales" },
];
